import * as angular from "angular";
import {IController} from "angular";

export class customerAddressesTableCtrl implements IController {

  customer: any;

  addresses: any;
  defaultAddressId: any;
  onCreate: Function;
  onChangeDefault: Function;
  onEdit: Function;
  onRemove: Function;

  /* @ngInject */
  constructor() {
  }

  $onInit() {

  }

  onDefaultSelect(address) {
    if (address.id !== this.defaultAddressId) {
      this.onChangeDefault({address: address})
    }
  }


}

angular
  .module('bringoz.admin.customers')
  .component('customerAddressesTable', {
    bindings: {
      addresses: '<',
      defaultAddressId: '<',
      onCreate: '&',
      onChangeDefault: '&',
      onEdit: '&',
      onRemove: '&'
    },
    template: require('./customer-addresses-table.html').default,
    controller: customerAddressesTableCtrl
  });
